import React from 'react';
import styled from 'styled-components';
import { Card, CardMedia, CardContent, Typography, Button } from '@mui/material';
import LockIcon from '@mui/icons-material/Lock';

const StyledCard = styled(Card)`
  position: relative;
  transition: transform 0.2s;
  
  &:hover {
    transform: translateY(-5px);
  }
`;

const PremiumBadge = styled.div`
  position: absolute;
  top: 10px;
  right: 10px;
  background: gold;
  padding: 5px 10px;
  border-radius: 15px;
  display: flex;
  align-items: center;
  gap: 5px;
`;

const TemplateCard = ({ template, onSelect }) => {
  const { name, thumbnail, isPremium } = template;

  return (
    <StyledCard>
      {isPremium && (
        <PremiumBadge>
          <LockIcon fontSize="small" />
          <Typography variant="caption">高级版</Typography>
        </PremiumBadge>
      )}
      <CardMedia
        component="img"
        height="200"
        image={thumbnail}
        alt={name}
      />
      <CardContent>
        <Typography variant="h6" gutterBottom>
          {name}
        </Typography>
        <Button
          variant="contained"
          color="primary"
          fullWidth
          onClick={onSelect}
        >
          使用此模板
        </Button>
      </CardContent>
    </StyledCard>
  );
};

export default TemplateCard; 